import React, { useEffect, useState } from 'react'
import { COLORS } from 'x/config/styles'
import XText from './XText'
import VStack from './VStack'

interface CountdownTimerProps {
  expiryDate: string
  expiredText: string
  expiredCallBack?: () => void
  showHours?: boolean
  showMinutes?: boolean
  showSeconds?: boolean
  showDays?: boolean
}

interface TimeLeft {
  days: number
  hours: number
  minutes: number
  seconds: number
  expired?: boolean
}

const XCountdownTimer = ({
  expiryDate,
  expiredText,
  showMinutes = true,
  showSeconds = true,
  showDays = true,
  showHours = true,
  expiredCallBack = null,
}: CountdownTimerProps) => {
  // const expiryDate = new Date('2025-07-21T13:32:16')
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    expired: false,
  })

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date()
      const diff = new Date(expiryDate).getTime() - now.getTime()

      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0, expired: true })
        clearInterval(intervalId) // stop it once expired
        expiredCallBack()
        return
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24)
      const minutes = Math.floor((diff / 1000 / 60) % 60)
      const seconds = Math.floor((diff / 1000) % 60)

      setTimeLeft({ days, hours, minutes, seconds })
    }, 1000)

    return () => clearInterval(intervalId) // Cleanup on unmount
  }, [])

  return (
    <VStack>
      {timeLeft.expired ? (
        <XText color={COLORS.RED}>{expiredText}</XText>
      ) : (
        <XText color={COLORS.GREEN}>
          {showDays && `${timeLeft.days} วัน `}
          {showHours && `${timeLeft.hours} ชั่วโมง `}
          {showMinutes && `${timeLeft.minutes} นาที `}
          {showSeconds && `${timeLeft.seconds} วินาที`}
        </XText>
      )}
    </VStack>
  )
}

export default XCountdownTimer
